import { Modal, ModalFuncProps } from 'ALIASED-antd';
import { ModalStaticFunctions } from 'ALIASED-antd/es/modal/confirm';
import { ModalProps } from 'antd';
import { ComponentType } from 'react';
import styled from 'styled-components';
import { dataTestIdFromTitle } from 'vl-common/src/utils';

export const StyledModal: ComponentType<ModalProps> = styled(Modal)`
  .ant-modal-content {
    padding: 0px;
  }

  .ant-modal-header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    padding: 16px 24px;
  }

  .ant-modal-body {
    padding: 16px 24px;
  }

  .ant-modal-footer {
    padding: 16px 24px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
  }
`;

const StyledAntModal = StyledModal as ComponentType<ModalProps> & ModalStaticFunctions;

const withModalRender = (method: typeof Modal.warning) => (config: ModalFuncProps) => {
  if (config.modalRender) {
    return method(config);
  }

  const testId = dataTestIdFromTitle(config?.title);

  return method({
    ...config,
    modalRender: (modal) => <div data-testid={testId}>{modal}</div>
  });
};

StyledAntModal.warning = withModalRender(Modal.warning);
StyledAntModal.success = withModalRender(Modal.success);
StyledAntModal.error = withModalRender(Modal.error);
StyledAntModal.confirm = withModalRender(Modal.confirm);
StyledAntModal.info = withModalRender(Modal.info);
StyledAntModal.warn = withModalRender(Modal.warn);

export { StyledAntModal };
